import * as actionTypes from './action-types'
import * as mutationTypes from './mutation-types'

export default {
    [actionTypes.OPEN_PENDING_CALL]({ commit }) {
        commit(mutationTypes.PENDING_CALL_OPENED)
    },
    [actionTypes.CLOSE_PENDING_CALL]({ commit }) {
        commit(mutationTypes.PENDING_CALL_CLOSED)
    }
}